import { create } from "zustand";

interface Oauth {
  request_id: string;
  title: string;
  description: string;
  auth_code_url: string;
}

interface OauthResponse {
  code: string;
  state: string;
}

interface OauthStore {
  oauth?: Oauth;
  oauthResponse: OauthResponse;
  cancellationError?: {
    error: string;
    errorDescription: string;
  };
  setOauth: (oauth: Oauth) => void;
  setOauthResponse: (oauthResponse: OauthResponse) => void;
  setCancellationError: (cancellationError: {
    error: string;
    errorDescription: string;
  }) => void;
}

const useOauthStore = create<OauthStore>((set) => ({
  oauth: undefined,
  oauthResponse: undefined,
  cancellationError: undefined,
  setOauth: (oauth: Oauth) => set({ oauth, cancellationError: undefined }),
  setOauthResponse: (oauthResponse: OauthResponse) => set({ oauthResponse }),
  setCancellationError: (error) => set({ cancellationError: error }),
}));

export default useOauthStore;
